import {SupportedLocales} from '@gl/types/locale.js';

export const audienceExportLang = {
  [SupportedLocales.EN]: {
    actions: {
      manage: 'Manage',
      extend: 'Extend',
      run: 'Run',
      enable: 'Enable',
      disable: 'Disable',
      authenticate: 'Authenticate',
      ingest: 'Ingest',
      viewInsights: 'View Insights',
    },
    tooltips: {
      ingest: {
        disabled:
          'Ingest is not supported for this destination. Please choose another export destination.',
      },
      insights: {
        disabled:
          'You must first ingest data before you can view insights for this destination.',
      },
    },
    event: {
      label: 'Export Audience',
    },
    destinations: {
      csv: {
        validator: {
          fileName: {
            message: 'Export file name required',
          },
          nonEmptyAdditionalFields: {
            message: 'You must enter a valid alias for each additional field',
          },
        },
      },
    },
  },
  [SupportedLocales.ES]: {
    actions: {
      manage: 'Administrar',
      extend: 'Ampliar',
      run: 'Ejecutar',
      enable: 'Habilitar',
      disable: 'Deshabilitar',
      authenticate: 'Autenticar',
      ingest: 'Ingestar',
      viewInsights: 'Ver Insights',
    },
    tooltips: {
      ingest: {
        disabled:
          'Ingestar no está soportado para esta plataforma. Por favor, elija otra plataforma de exportación.',
      },
      insights: {
        disabled:
          'Debe primero ingerir datos antes de poder ver insights para esta plataforma.',
      },
    },
    event: {
      label: 'Exportar audiencia',
    },
    destinations: {
      csv: {
        validator: {
          fileName: {
            message: 'Nombre de archivo de exportación requerido',
          },
          nonEmptyAdditionalFields: {
            message: 'Debe ingresar un alias válido para cada campo adicional',
          },
        },
      },
    },
  },
};
